import { createApi } from "@reduxjs/toolkit/query/react";

import { APP_BASE_URL, GET_ALL_USER } from "../../../Common/EndPoints";
import axiosBaseQuery from "../rtk-query-axios.service";

export type User = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
};

export const userApi = createApi({
  reducerPath: "userAPI",
  baseQuery: axiosBaseQuery,
  tagTypes: ["users"],
  endpoints: (builder) => ({
    getUser: builder.query<User[], { customerIds: string }>({
      query: (params) => ({
        url: APP_BASE_URL + GET_ALL_USER, // URL to create a new post
        method: "GET",
        params,
      }),
      transformResponse: (_response: { error: any; success: any; data: User[] }): User[] => _response.data,
    }),
  }),
});
